import styled from 'styled-components';
import C from '@assets/themes/colors';
import { isCloseToWhite } from '@utils/colors'

interface IProps {
  selected?: boolean;
  multiSelected?: boolean;
  leftValue?: string;
  topValue?: string;
  display?: string;
  smallContainer?: boolean;
  fontContainer?: boolean;
}

interface ISquareProps {
  multiSelected?: boolean;
  color: string;
}

interface IFontProps {
  fontFamilyValue: string;
}

export const Root = styled.div`
  font-family: Roboto;
  display: inline-block;
  position: relative;
  width: ${(props: IProps) => (props.fontContainer ? 'auto' : props.smallContainer ? `60px` : `173px`)};
  height: ${(props: IProps) => (props.fontContainer ? 'auto' : props.smallContainer ? `56px` : `147px`)};
  margin: ${(props: IProps) => (props.fontContainer || props.smallContainer ? `0px 10px 35px 10px` : `15px 10px 25px 10px`)};
  box-sizing: border-box;
  border: ${(props: IProps) => (props.multiSelected ? `solid 2px ${C.ORANGE}` : `auto`)};
  border-radius: 5px;
  transition: transform 0.2s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transform: ${(props: IProps) => (props.selected ? `scale(1.05)` : `auto`)};
  box-shadow: ${(props: IProps) => (props.selected ? `4px 4px 20px 2px rgba(0, 0, 0, 0.05)` : `auto`)};
  &:hover {
    box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.05);
    transform: scale(1.05);
  }
`;

export const Container = styled.div`
  padding: ${(props: IProps) => (props.fontContainer ? '10px 0px' : '15px 15px')};
  display: flex;
  height: 20px;
  position: ${(props: IProps) => (props.fontContainer ? 'absolute' : 'relative')};
`;

export const ImgOutsideContainer = styled.div`
  text-align: center;
  box-sizing: border-box;
  width: 100%;
  object-fit: contain;
`;

export const ImgContainer = styled.img`
  width: 100%;
  height: 97px;
  display: inline-block;
  border-radius: 5px 5px 0px 0px;
  text-align: center;
  object-fit: contain;
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUAQMAAAC3R49OAAAABlBMVEX////09PQtDxrOAAAAE0lEQVQI12P4f4CBKMxg/4EYDAAFkR1NiYvv7QAAAABJRU5ErkJggg==');
	background-image: linear-gradient(45deg, $color 25%, transparent 25%), linear-gradient(-45deg, $color 25%, transparent 25%), linear-gradient(45deg, transparent 75%, $color 75%), linear-gradient(-45deg, transparent 75%, $color 75%);
  background-size: 20px 20px;
  background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
`;

export const TextInfo = styled.div`
  width: ${(props: IProps) => (props.fontContainer ? '220px' : '125px')};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #8891a0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Square = styled.div`
  width: 100%;
  height: 100%;
  border-radius: ${(props: ISquareProps) => (props.multiSelected ? `3px` : `5px`)};
  background-color: ${(props: ISquareProps) => props.color };
  border: ${(props: ISquareProps) => props.color ? isCloseToWhite(props.color) ? "solid 2px #ebebee" : "solid 2px transparent" :'' };
  margin: 0px 9px 9px 0px;
  position: relative;
  display: flex;
  box-sizing: border-box;
`;

export const Font = styled.div`
  width: 220px;
  height: 48px;
  border-radius: 5px;
  background-color: rgba(32, 64, 120, 0.1);
  font-size: 20px;
  padding: 10px;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  align-items: center;
  justify-content: center;
  font-family: ${(props: IFontProps) => (props.fontFamilyValue ? `font-${props.fontFamilyValue}` : '')}, Roboto;
  text-align: center;
  vertical-align: middle;
  line-height: 28px;
  color: ${C.DARK_BLUE};
  word-break: auto;
`;

export const FontMaxWidth = styled.div`
  width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Tooltip = styled.div`
  position: fixed;
  padding: 9px 12px;
  width: auto;
  z-index: 1000;
  background-color: ${C.DARKEST_GRAY};
  font-size: 11px;
  font-weight: 500;
  color: ${C.DARKER_WHITE};
  white-space: pre;
  left: ${(props: IProps) => (props.leftValue ? props.leftValue : '')};
  top: ${(props: IProps) => (props.topValue ? props.topValue : '')};
  display: ${(props: IProps) => (props.display ? props.display : '')};
`;